import { render } from "./PlanosPage.vue?vue&type=template&id=4277007a"
import script from "./PlanosPage.vue?vue&type=script&lang=js"
export * from "./PlanosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__